import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Button, Space, Input} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";

export default class WithdrawDepositAudit extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getMagicPowerWithdrawList,
        otherParam: null,
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          hideSeniorBtn:  true,
          hideInput: true,
          placeholder: '',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {

            return true;
          },
        }
      }
    }
  }


  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          field: "status",
          name: "状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '待审核',
              value: 'audit',
            },
            {
              title: '审核通过',
              value: 'success',
            },
            {
              title: '审核拒绝',
              value: 'refuse',
            },
          ]
        },
        {
          field: "userName",
          name: "申请人",
          type: 'Input',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
        },
      ],
    }
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '提现金额(￥)',
        dataIndex: 'realOriginRmbMoney',
        key: 'realOriginRmbMoney',
      },
      {
        title: '提现手续费(￥)',
        dataIndex: 'realServiceCharge',
        key: 'realServiceCharge',
      },
      {
        title: '实际到账(￥)',
        dataIndex: 'realGetRmbPrice',
        key: 'realGetRmbPrice',
      },
      {
        title: '申请时间',
        dataIndex: 'addTime',
        key: 'addTime',
        render: (text) => {
          let time = TimeHelp.getYMDHM(text);
          return <div>{time}</div>
        }
      },
      {
        title: '申请人',
        dataIndex: 'createName',
        key: 'createName',
      },
      {
        title: '到账账户',
        dataIndex: 'alipayAccount',
        key: 'alipayAccount',
        render: (text,record) => {
          return <Space>
            <div>{record.alipayAccount}</div>
            {record.realName && <div>({record.realName})</div>} 
          </Space>
        }
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: (text,record) => {
          return <div>
            <div>{{
              'audit': <span style={{color: 'darkorange'}}>待审核</span>,
              'success': <span style={{color: 'limegreen'}}>已通过</span>,
              'refuse': <span style={{color: 'red'}}>未通过</span>,
            }[text]}</div>
          </div>
        }
      },
      {
        title: '操作',
        width: 200,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit && record.status === 'audit'
                  ? <Space>
                        <Button
                          size={"small"}
                          type={"primary"}
                          onClick={()=>{
                            this.changeState(record, 'success')
                          }}
                        >
                          通过
                        </Button>
                        <Button
                          size={"small"}
                          type={"primary"}
                          danger={true}
                          onClick={()=>{
                            this.changeState(record, 'refuse')
                          }}
                        >
                          拒绝
                        </Button>
                  </Space>
                  : null
              }
              {
                record.status === 'refuse'
                  ? <div style={{maxWidth: '200px', maxHeight: '200px', overflow: 'auto'}}>
                    原因：{record.auditMessage || '未填写'}
                  </div>
                  :null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(record, status) {
    let reason = null;
    Modal.confirm({
      title: '提示',
      content: status==='success'
        ?<div>
          确定<span style={{color: "limegreen", fontSize: '20px'}}>通过</span>用户：{record.createName}的 <span style={{fontSize: '20px'}}>￥{record.realOriginRmbMoney}</span> 提现申请么？
        </div>
        :<div>
          确定<span style={{color: "red", fontSize: '20px'}}>拒绝</span>用户：{record.createName}的 <span style={{fontSize: '20px'}}>￥{record.realOriginRmbMoney}</span> 提现申请么？
          <div style={{marginTop: '20px'}}>
            <Input.TextArea
              placeholder={'填写拒绝原因（可选）'}
              maxLength={100}
              onChange={(e)=>{
                reason = e.target.value;
              }}
            />
          </div>
        </div>,
      okText: status==='success'?'确定通过':'确定拒绝',
      cancelText: '取消',
      okType: status==='success'?'primary':'danger',
      onOk: () => {
        let param = {
          _id: record._id,
          auditMessage: reason,
          status,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.magicPowerWithdraw, successCB, failureCB, param);
      }
    })
  }
}